"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  box: {
    fontFamily: "IranSansX",
    display: "flex",
    justifyContent: "center",
    marginBottom: "90px",
    marginTop: "7px",
    direction: "rtl",
    position: "relative",
    top: "0",
    left: "0"
  },
  arrow: function arrow(props) {
    return {
      "& p": {
        color: props.white ? _variables.colors.hare : _variables.colors.wolf
      }
    };
  },
  lengthArrow: {
    position: "absolute",
    top: "100%",
    "& p": {
      margin: "0",
      fontSize: "14px" // color: colors.wolf,

    }
  },
  lengthArrowIcon: {
    display: "flex",
    justifyContent: "center",
    height: "40px",
    "& svg": {
      transform: "rotate(90deg)",
      width: "12px !important"
    }
  },
  widthArrow: {
    position: "absolute",
    left: "100%",
    top: "-20px",
    display: "flex",
    alignItems: "center",
    "& p": {
      width: "95px",
      textAlign: "left",
      alignSelf: "flex-start",
      margin: "0",
      fontSize: "14px",
      color: _variables.colors.wolf
    }
  },
  widthArrowIcon: {
    marginRight: "10px",
    "& svg": {
      width: "30px !important",
      height: "38px",
      transform: "rotate(139deg)"
    }
  },
  heightArrow: {
    position: "absolute",
    right: "calc(100% + 20px)",
    top: "60%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    "& p": {
      width: "100px",
      margin: "0",
      fontSize: "14px",
      marginRight: "10px",
      color: _variables.colors.wolf
    }
  },
  heightArrowIcon: {
    "& svg": {
      height: "unset",
      width: "12px !important"
    }
  },
  boxIcon: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    "& svg": {
      width: "100%"
    }
  }
}), {
  name: 'pds-parcel-preview'
});
exports.useStyles = useStyles;